import React from "react";
import UNSCTable from "./UNSCTable/UNSCTable";

export default function UNSCCard(props) {

    const { unsc_data } = props

    const hasSource = Object.keys(unsc_data?.source || {}).length > 0;

    if (!hasSource) return null;

    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                UNSC - Match por similaridade encontrado
            </p>
            <UNSCTable unsc_data={unsc_data.source} />
        </div>
    )
}